import React, { useState } from 'react';
import "./ModuleStepper.scss";
import CircleNotActive from "../../../images/circle-not-active.svg";
import CircleActive from "../../../images/circle-active.svg";
import CompletedIndicatorIcon from "../../../images/CompletedIndicatorIcon.svg";

const ModuleStepper = ({activeStep, mlrData, steps }) => {
    
    
    // if (mlrData?.deckType === 1) {
    //   const selectTemplateIndex = steps.indexOf('Select Template');
    //   if (selectTemplateIndex > -1) {
    //     steps.splice(selectTemplateIndex, 1);
    //   }
    
    //   const authorEDetailIndex = steps.indexOf('Author eDetail');
    //   if (authorEDetailIndex > -1) {
    //     steps[authorEDetailIndex] = 'Author Template';
    //   }
    // }

    const getActiveColor = (index) => {
      if (activeStep > index + 1) {
        return 'selected_green_tick'; // Step is completed
      } else if (activeStep === index + 1) {
        return 'selected_gray_tick'; // Step is currently active
      } else {
        return 'selected_dark_gray_tick'; // Future step
      }
    };

    return (
      <>
        <div class="stepper"> 
          <div class="line2"></div>
          {steps.map((li, index) => (
            <>
              <div class="step">
                <div className="step-label">{li}</div>
                <div class="circle">
                  <img
                    src={
                      activeStep === index
                        ? CircleActive // Active step image
                        : activeStep > index
                        ? CompletedIndicatorIcon // Completed step image
                        : CircleNotActive  //Default step image
                    }
                    alt="step-icon"
                    // className={`circle-image ${activeStep === index ? 'active' : ''}`}
                  />
                </div>
              </div>
              {/* {index < steps.length - 1 && <div class={`line ${getActiveColor(index)}`} style={{backgroundColor:activeStep-1 < index ? '':'#203662'}}></div>} */}
              {index < steps.length - 1 && <div class={`line ${getActiveColor(index)}`}></div>}
              </>
          ))}
          <div class="line2"></div>
        </div>
        </>
    )
}

export default ModuleStepper;